define([
], function () {

  function SourceInfo(model, channels) {
    this.model = model;
    this.channels = channels;
  }

  SourceInfo.prototype.isServiceAvailable = function (id) {
    var sources = this.model.get("sources.sources");
    if (!sources) {
      return false;
    }
    var channelUrl = this.channels.at(0).get('url');
    var services = sources[channelUrl] && sources[channelUrl].services;
    var hasService;
    hasService = services && services.length && services.find(function (service) { return service.id === id });
    return hasService;
  }

  return SourceInfo;
});